import { useState as p, useEffect as v } from "react";
function m(o) {
  const { validatePreviousSteps: i, currentStepId: t, context: a, steps: d } = o, [u, f] = p(!1);
  return v(() => {
    async function c() {
      var r, n;
      if (!i) return !0;
      const s = [d].find((e) => e.find((l) => t === l.id)) || [];
      for (const e of s) {
        if (t === e.id)
          break;
        if ((r = e.validation) != null && r.schema)
          try {
            await ((n = e.validation) == null ? void 0 : n.schema).validate(a.form.values);
          } catch {
            return a.wizard.dispatch({
              type: "GOTO_STEP",
              stepId: e.id,
              values: a.form.values
            }), !1;
          }
      }
      return !0;
    }
    c().then((s) => f(s));
  }, [i, t]), u;
}
export {
  m as default
};
